import { createContext, ReactNode } from 'react'

import { BaseProps } from './types'

export type FeatureCardContextType = BaseProps & {
  sectionName: ReactNode | null
  heading: ReactNode | null
  icon: ReactNode | null
  viewAll: ReactNode | null
  content: ReactNode | null
  left: ReactNode | null
  right: ReactNode | null
}

export const FeatureCardContext = createContext<FeatureCardContextType>(
  {} as FeatureCardContextType,
)
